/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  Paper, Typography, Grid,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import placementTestActions from '../../../redux/actions/placementTestActions';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  cardHeader: {
    backgroundColor: '#1bb1e4',
    color: '#FFF',
    width: '100%',
  },
  cardBody: {
    width: '90%',
    margin: 'auto',
    textAlign: 'center',
    paddingTop: '1em',
  },
  center: {
    textAlign: 'center',
    margin: 'auto',
    width: '90%',
  },
  title: {
    padding: '1em',
    textAlign: 'center',
  },
  subTitle: {
    paddingBottom: '0.5em',
  },
  link: {
    color: '#1bb1e4',
  },
}));
const NoGroupAssociatedCard = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <Grid container direction="row" className={classes.center}>
        <Grid item lg={12}>
          <Typography variant="body1" className={classes.title} style={{ fontWeight: 900 }}>
            Your course programme isn’t available yet.  Don’t worry, it’s coming soon.
          </Typography>
        </Grid>
        <Grid item lg={12}>
          <Typography variant="body1" className={classes.subTitle}>
            However, if you think you should already have access to your programme and content, try signing out and signing back in later.
          </Typography>
          <Typography variant="body1" className={classes.subTitle}>
            {'If your course is still inaccessible, please contact '}
            <Link push to="/help" className={classes.link}>
              Help
            </Link>
            .
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

const actionCreators = {
  clearTest: placementTestActions.clearTest,
};

function mapState(state) {
  const { userData } = state.user;
  const { semester, company, _id } = userData;
  const { data } = state.group;
  return {
    semester, company, _id, data,
  };
}
export default connect(mapState, actionCreators)(NoGroupAssociatedCard);
